import { FunctionComponent, memo, useEffect, useState } from 'react';
import { FormControl, FormControlLabel, Switch } from '@material-ui/core';
import { useChangeTestDeviceMutation } from '../../../../store/api-slice';
import { MedisanteDevice } from '../../../../pages/Device/types';
import { useConfig } from '../../../../eliot-components/src/ConfigProvider/hooks';
import { useAuthUser } from '../../../../contexts/AuthProvider/hooks';

interface Props {
  devices: MedisanteDevice[];
  onTestDeviceChange(isTestDevice: boolean, err: any): void;
}

const TestDeviceSwitch: FunctionComponent<Props> = memo(
  ({ devices, onTestDeviceChange }) => {
    const [testDevices, { isLoading }] = useChangeTestDeviceMutation();
    const [testdevice, setTestdevice] = useState(false);
    const config = useConfig();
    const { authUser } = useAuthUser();

    useEffect(() => {
      if (
        devices.length > 0 &&
        devices[0].properties &&
        devices[0].properties.testdevice
      ) {
        setTestdevice(devices[0].properties.testdevice.length > 0);
      }
    }, [devices]);

    return (
      <FormControl>
        <FormControlLabel
          control={
            <Switch
              color="primary"
              checked={testdevice}
              disabled={isLoading}
              onChange={(e) => {
                testDevices({
                  apiBaseURL: config.apiBaseURL,
                  orgIDs:
                    authUser.selectedOrgs.length === 1
                      ? authUser.selectedOrgs
                      : authUser.orgs.map((o) => o.id),
                  devices,
                  isTest: e.target.checked,
                })
                  .then(() => {
                    onTestDeviceChange(!e.target.checked, null);
                  })
                  .catch((err) => {
                    onTestDeviceChange(false, err.message);
                  });
              }}
            />
          }
          label="Test device"
        />
      </FormControl>
    );
  }
);

export default TestDeviceSwitch;
